/**
 * A single bottom pill reused by the offline indicator and the update prompt.
 * Kept deliberately separate from the legacy toast system: toasts auto-dismiss,
 * and both of these need to persist until the underlying condition changes.
 */

let element = null;

function ensureElement() {
  if (element) return element;

  element = document.createElement('div');
  element.className = 'app-notice';
  element.setAttribute('role', 'status');
  element.hidden = true;
  document.body.appendChild(element);
  return element;
}

/**
 * @param {object} opts
 * @param {string} opts.message
 * @param {string} [opts.variant]     Appended as `app-notice--<variant>`.
 * @param {string} [opts.actionLabel] Renders a button when present.
 * @param {() => void} [opts.onAction]
 */
export function showNotice({ message, variant, actionLabel, onAction }) {
  const el = ensureElement();
  el.className = `app-notice${variant ? ` app-notice--${variant}` : ''}`;
  el.innerHTML = `<span></span>`;
  el.firstChild.textContent = message;

  if (actionLabel && onAction) {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = actionLabel;
    button.addEventListener('click', onAction);
    el.appendChild(button);
  }

  el.hidden = false;
}

export function hideNotice() {
  if (element) element.hidden = true;
}
